<template>
  <div class="header-tabbar-wrapper">
    <div class="auto-box herder-box">
      <div class="header-logo"  @click="handleToHome">
        <img :src="en.logo" alt="">
      </div>
      <div class="header-right">
        <div class="menu-wrapper">
          <div
            class="menu-item"
            v-for="item in showMenu"
            :key="item.subjectId"
            :class="{ active: active === item.subjectName }"
            @click="handleChange(item)"
          >
            <span>{{ item.subjectName }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import en from '@/utils/en'
const router = useRouter()
const route = useRoute()
onMounted(() => {
  active.value = route.name || "EnHome"
})
const active = ref("EnHome")
const handleChange = (item) => {
  active.value = item.subjectName
  router.push(item.path)
}
const showMenu = ref([
  {
    subjectId: 1,
    subjectName: 'Home',
    path: '/en',
  },
  {
    subjectId: 2,
    subjectName: 'Programme',
    path: '/en/programme',
  },
  {
    subjectId: 3,
    subjectName: 'Contact',
    path: '/en/contact',
  },
])

const handleToHome = () => {
  window.location.href = '/en'
}
</script>
<style lang="less" scoped>
.header-tabbar-wrapper {
  position: fixed;
  z-index: 99;
  top: 0;
  width: 100%;
  height: 60px;
  background: rgba(255, 255, 255);
  line-height: 60px;
}
.herder-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .header-logo {
    width: 358px;
    height: 100%;
    display: flex;
    align-items: center;
    img {
      height: 26px;
      cursor: pointer;
    }
  }
}
.header-right {
  display: flex;
  align-items: center;
}

.menu-wrapper {
  display: flex;
  column-gap: 42px;
  align-items: center;
}
.menu-item {
  position: relative;
  cursor: pointer;
  max-width: 80px;
}
.menu-item.active {
  color: @theme-color;
  &::after {
    content: "";
    width: 100%;
    height: 4px;
    position: absolute;
    bottom: 11px;
    left: 0;
    background: @theme-color;
    border-radius: 2px;
  }
}
</style>
